import React from "react";
import { whatsappLink, formatPhone } from "../lib/whatsapp";
import { MessageCircle } from "lucide-react";

export default function WhatsAppButton({ number, label = "WhatsApp", testId, size = "md" }) {
  const href = whatsappLink(number);
  if (!href) return null;
  const cls =
    size === "sm"
      ? "text-[10px] px-2 py-1 gap-1"
      : "text-xs px-3 py-1.5 gap-2";
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      data-testid={testId || "whatsapp-link"}
      className={`inline-flex items-center ${cls} font-mono uppercase tracking-[0.2em] border border-[#25D366]/60 text-[#25D366] hover:bg-[#25D366] hover:text-black transition-colors`}
      title={formatPhone(number)}
    >
      <MessageCircle className={size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5"} />
      {label}
    </a>
  );
}
